/* eslint-disable linebreak-style */
import React from 'react';
const AccidentalDeathAndDismembermentStepShared = () => (
  <ol>
    <li>
    COPIES OF YOUR OFFICE RECORDS IN CONNECTION WITH THIS ACCIDENTAL INJURY
    </li>
  </ol>
);

export default AccidentalDeathAndDismembermentStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.AccidentalDeathAndDismembermentStep/components/AccidentalDeathAndDismembermentStepShared.js